import { render, staticRenderFns } from "./ColorPickerPopover.vue?vue&type=template&id=8d846468&"
import script from "./ColorPickerPopover.vue?vue&type=script&lang=js&"
export * from "./ColorPickerPopover.vue?vue&type=script&lang=js&"
import style0 from "./ColorPickerPopover.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ColorPickerPopover.vue"
export default component.exports